import { render, staticRenderFns } from "./ServiceCallList.vue?vue&type=template&id=89449040&"
import script from "./ServiceCallList.vue?vue&type=script&lang=js&"
export * from "./ServiceCallList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCallList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports